<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width">
      <input matInput autocomplete="off" formControlName="Date" [matDatepicker]="pickerFrom" placeholder="Fecha">
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
      <mat-error *ngIf="f.Date.errors && f.Date.errors.required">
          Ingrese la fecha
      </mat-error>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #doctor matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService">
      <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
          <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
              {{service.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #doctor matInput placeholder="Especialidad" formControlName="Specialty" [matAutocomplete]="autSpecialty">
      <mat-autocomplete #autSpecialty="matAutocomplete" [displayWith]="filterCompleteSpecialities.displayFn">
          <mat-option *ngFor="let speciality of filteredSpecialitiesOptions | async" [value]="speciality">
              {{speciality.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
      <input type="text" #practiceRegion matInput placeholder="Práctica" formControlName="PracticeRegion" [matAutocomplete]="autPracticeRegion">
      <mat-autocomplete #autPracticeRegion="matAutocomplete" [displayWith]="filterCompletePracticesRegion.displayFn">
          <mat-option *ngFor="let practiceRegion of filteredPracticesRegionOptions | async" [value]="practiceRegion">
              {{practiceRegion.Name}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
  <div class="full-width">
      <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <div>
     <mat-checkbox *ngIf="canViewOtherCenters" formControlName="ViewOtherCenters"><span>Ver turnos otras sedes</span> </mat-checkbox>
      <mat-checkbox formControlName="OrderByPatient"><span>Ordenar por paciente</span> </mat-checkbox>
  </div>
</form>
